/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */
import { Box, Paper, Typography, styled } from "@mui/material";

export const VariantGroupsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "14px",
  marginTop: "24px",
});

export const SectionTitle = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "16px",
  fontWeight: 600,
});

export const VariantCard = styled(Paper)({
  border: "1px solid #ffb980",
  borderRadius: "12px",
  boxShadow: "none",
  overflow: "hidden",
});

export const VariantHeader = styled(Box)({
  alignItems: "center",
  backgroundColor: "#fff7ed",
  borderBottom: "1px solid #ffb980",
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  padding: "10px 14px",
});

export const VariantHeaderTitle = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "16px",
  fontWeight: 600,
  minWidth: 0,
});

export const VariantBody = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "16px",
});

export const CategoryCard = styled(Box)({
  border: "1px solid #e0e0e0",
  borderRadius: "10px",
  overflow: "hidden",
});

export const CategoryHeader = styled(Box)({
  backgroundColor: "#f8fafc",
  borderBottom: "1px solid #e0e0e0",
  padding: "10px 14px",
});

export const CategoryTitle = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
  fontWeight: 600,
});

export const RowHeader = styled(Box)({
  display: "grid",
  gap: "12px",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  padding: "10px 14px",
  backgroundColor: "#fcfcfd",
  borderBottom: "1px solid #e0e0e0",
  "@media (max-width: 720px)": {
    gridTemplateColumns: "1fr",
  },
});

export const RowHeaderText = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "12px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
});

export const Row = styled(Box)({
  display: "grid",
  gap: "12px",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  padding: "10px 14px",
  borderBottom: "1px solid #e0e0e0",
  "&:last-of-type": {
    borderBottom: "none",
  },
  "@media (max-width: 720px)": {
    gridTemplateColumns: "1fr",
  },
});

export const Cell = styled(Typography)({
  color: "rgba(81, 81, 82, 1)",
  fontSize: "14px",
  wordBreak: "break-word",
});

export const EmptyState = styled(Typography)({
  color: "rgba(112, 112, 112, 1)",
  fontSize: "14px",
  fontStyle: "italic",
});

export const ActionGroup = styled(Box)({
  alignItems: "center",
  display: "flex",
  gap: "2px",
});
